import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Box, useBreakpointValue, } from '@spothero/ui';
import SearchDateTimePickers from 'common/search-controls/date-time-pickers/SearchDateTimePickers';
import { useSelector } from 'react-redux';
import { dateTimePickerStyleOverrides } from 'common/styles/date-time-picker-overrides';
const DateTimeRangeModal = ({ submitDisabled = false, onUpdateDateTime, onDateTimeChange, onModalClose, modalTitle = '', }) => {
    const [showModal, setShowModal] = useState(true);
    const isMobile = useBreakpointValue({ base: true, tablet: false });
    const { city: { data: { timezone }, }, user: { data: { isAdmin }, }, searchRequest: { starts, ends }, } = useSelector((state) => state);
    const handleUpdateSearchClick = () => {
        onUpdateDateTime();
        setShowModal(false);
    };
    const handleCloseModal = () => {
        if (onModalClose) {
            onModalClose();
        }
        setShowModal(false);
    };
    return (<Modal isOpen={showModal} size={isMobile ? 'full' : 'sm'} hasHeader hasFooter isCentered closeOnOverlayClick={false} contentStyling={{
            width: '563px',
            maxWidth: { desktop: '100%' },
            maxHeight: '100%',
            top: {
                desktop: '0',
                tablet: '0',
            },
            borderRadius: { base: 0, desktop: 'md', tablet: 'md' },
        }} onClose={handleCloseModal} sx={{ height: { tablet: 'initial' } }} autoFocus={false}>
            <ModalHeader fontSize="lg" mr="8" data-testid="DateTimeRangeModal-header">
                {modalTitle}
            </ModalHeader>
            <ModalBody mb="12" mt={{ desktop: '0.5', tablet: '0.5', mobile: '8' }} data-testid="DateTimeRangeModal-body">
                <Box flexGrow={1} sx={{
            ...dateTimePickerStyleOverrides,
            '.SearchDateTimePickers': {
                width: '100%',
                '.DatePicker-input-container': {
                    '> span': {
                        width: '100%',
                    },
                },
                '& .DateTimePicker-end .DatePicker, & .DateTimePicker-end .TimePicker, ': {
                    marginBottom: 0,
                },
            },
        }} data-testid="DateTimeRangeModal-SearchDateTimePickers" className="DateTimeRangeModal-SearchDateTimePickers">
                    <SearchDateTimePickers 
    // @ts-ignore
    isAdmin={isAdmin} isMobile={isMobile} isMonthly={false} timezone={timezone} onChange={onDateTimeChange} starts={starts} ends={ends} parentClassname=".DateTimeRangeModal-SearchDateTimePickers"/>
                </Box>
            </ModalBody>
            <ModalFooter data-testid="DateTimeRangeModal-footer">
                <Button variant="secondary" mr="4" onClick={handleCloseModal} data-testid="DateTimeRangeModal-cancel-button">
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleUpdateSearchClick} isDisabled={submitDisabled} data-testid="DateTimeRangeModal-confirm-button">
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>);
};
DateTimeRangeModal.propTypes = {
    submitDisabled: PropTypes.bool,
    onUpdateDateTime: PropTypes.func.isRequired,
    onDateTimeChange: PropTypes.func.isRequired,
    modalTitle: PropTypes.string.isRequired,
    onModalClose: PropTypes.func,
};
export default DateTimeRangeModal;
